import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

const API_URL = import.meta.env.VITE_API_URL;

export interface CandidateAvatarProps {
  candidateId: number | null | undefined;
  firstName?: string | null;
  lastName?: string | null;
  className?: string;
  alt?: string;
}

function getInitials(first?: string | null, last?: string | null): string {
  const f = (first ?? "").trim();
  const l = (last ?? "").trim();
  if (!f && !l) return "?";
  const fi = f ? f[0]! : "";
  const li = l ? l[0]! : "";
  const out = `${fi}${li}`.toUpperCase();
  return out || "?";
}

export function CandidateAvatar({
  candidateId,
  firstName,
  lastName,
  className,
  alt,
}: CandidateAvatarProps) {
  const imageSrc = candidateId != null ? `${API_URL}/candidates/${candidateId}/image` : undefined;
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  const initials = getInitials(firstName, lastName);

  return (
    <Avatar className={cn("h-9 w-9 border", className)}>
      {imageSrc ? <AvatarImage src={imageSrc} alt={alt ?? fullName ?? "Avatar"} /> : null}
      <AvatarFallback
        className={cn(
          "bg-gradient-to-br from-slate-200 to-slate-300 text-slate-700 font-medium",
        )}
      >
        {initials}
      </AvatarFallback>
    </Avatar>
  );
}

export default CandidateAvatar;
